﻿/** Mirrors backend MessageChannelTypesEnum (InApp=1, WhatsApp=2). */
export enum MessageChannelTypesEnum {
  InApp = 1,
  WhatsApp = 2,
}
